import React from 'react';
import "./TopWidget.css"
import { Row, Col } from "antd";

import { ReactComponent as storeIcon } from '../../../assets/icons/ic_store.svg';
import { ReactComponent as promotionIcon } from '../../../assets/icons/ic_promotion.svg';
import { ReactComponent as productIcon } from '../../../assets/icons/ic_product.svg';
import { ReactComponent as followerIcon } from '../../../assets/icons/ic_follower.svg';
import CategoryItemWidget from './CategoryItemWidget/CategoryItemWidget';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { UpdateCurrentRoot } from 'redux/actions/appActions';
import {  ROUTE_IMAGE_LIST, ROUTE_PROFILE, ROUTE_USERS, ROUTE_VIDEO_LIST } from 'navigation/CONSTANTS';

const TopWidget = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    return (
        <div>
            <Row align={'middle'} gutter={32}>
                
                <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                    <CategoryItemWidget
                        icon={followerIcon}
                        title="Super Admin Setup"
                        count={''}
                        type="Profile"
                        onClick={() => {
                            dispatch(UpdateCurrentRoot({ currentRoute: ROUTE_PROFILE}))
                            history.push(ROUTE_PROFILE)
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                    <CategoryItemWidget
                        icon={storeIcon}
                        title="Image List"
                        count={''}
                        type="Images"
                        onClick={() => {
                            dispatch(UpdateCurrentRoot({ currentRoute: ROUTE_IMAGE_LIST}))
                            history.push(ROUTE_IMAGE_LIST)
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                    <CategoryItemWidget
                        icon={promotionIcon}
                        title="Video List"
                        count={''}
                        type="Videos"
                        onClick={() => {
                            dispatch(UpdateCurrentRoot({ currentRoute: ROUTE_VIDEO_LIST}))
                            history.push(ROUTE_VIDEO_LIST)
                        }}
                    />
                </Col>
                <Col xs={24} sm={12} md={12} lg={6} xl={6}>
                    <CategoryItemWidget
                        icon={followerIcon}
                        title="Users List"
                        count={''}
                        type="Users List"
                        onClick={() => {
                            dispatch(UpdateCurrentRoot({ currentRoute: ROUTE_USERS}))
                            history.push(ROUTE_USERS)
                        }}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default TopWidget;